import { render, staticRenderFns } from "./DisGeNET.vue?vue&type=template&id=40447215&"
import script from "./DisGeNET.vue?vue&type=script&lang=js&"
export * from "./DisGeNET.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports